import { render, staticRenderFns } from "./dianzishu.vue?vue&type=template&id=d2c80f34&"
import script from "./dianzishu.vue?vue&type=script&lang=js&"
export * from "./dianzishu.vue?vue&type=script&lang=js&"
import style0 from "./dianzishu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports